module.exports = __webpack_public_path__ + "static/media/laxmirajmokuf3.49d0c8ad.png";